var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEdit(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 18,
    viewBox: "0 0 17 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.2407 2.8699L13.2857 1.82791C12.9165 1.4251 12.2924 1.39317 11.884 1.75621L10.3213 3.14559L12.6194 5.68265L14.1714 4.28976C14.5854 3.91815 14.6166 3.28005 14.2407 2.8699ZM1.5 10.9881L9.2002 4.14227L11.5031 6.68456L3.90674 13.5024H1.5V10.9881ZM15.3465 1.85642L14.3915 0.814429C13.4686 -0.192594 11.9083 -0.272411 10.8874 0.635181L0.335571 10.0162C0.122122 10.206 0 10.478 0 10.7636V14.0024C0 14.5546 0.447715 15.0024 1 15.0024H4.09822C4.34478 15.0024 4.58266 14.9113 4.76616 14.7466L15.1733 5.40609C16.2084 4.47706 16.2863 2.88181 15.3465 1.85642ZM16 16.4998H0V17.9998H16V16.4998Z",
    fill: "#FF4F12"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.efc04c305ce008e35b9c3729ee82854c.svg";
export { ForwardRef as ReactComponent };